import React, { Component } from "react";
import { Button, Container, Row, Form, Col, Offcanvas } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";

import LoadingOverlay from "./LoadingOverlay";
export default class Charttypemaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.charttypemaster_Id,
          sortable: true,
          cell: (row) => <span>{row.charttypemaster_Id}</span>,
        },
        {
          name: "Chart Id",
          selector: (row, i) => row.chartId,
          sortable: true,
          cell: (row) => <span>{row.chartId}</span>,
        },
        {
          name: "Chart Name",
          selector: (row, i) => row.chartName,
          sortable: true,
          cell: (row) => <span>{row.chartName}</span>,
        },
        {
          name: "Chart Description",
          selector: (row, i) => row.chartDescription,
          sortable: true,
          cell: (row) => <span>{row.chartDescription}</span>,
        },
        {
          name: "Minimum Height",
          selector: (row, i) => row.minHeight,
          sortable: true,
          cell: (row) => <span>{row.minHeight}</span>,
        },
        {
          name: "Maximum Height",
          selector: (row, i) => row.maxHeight,
          sortable: true,
          cell: (row) => <span>{row.maxHeight}</span>,
        },
        {
          name: "Minimum Width",
          selector: (row, i) => row.minWidth,
          sortable: true,
          cell: (row) => <span>{row.minWidth}</span>,
        },
        {
          name: "Maximum Width",
          selector: (row, i) => row.maxWidth,
          sortable: true,
          cell: (row) => <span>{row.maxWidth}</span>,
        },
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.handleEnterEditMode(row)}
                className="bi bi-pen"
              ></Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      chartId: "",
      chartName: "",
      chartDescription: "",
      minHeight: "",
      maxHeight: "",
      minWidth: "",
      maxWidth: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFour: "",
      dummyFive: "",
      dummysix: "",
      dummyseven: "",
      charttypemaster_Id: "",
      isEditing: false,
      isNewEntry: false,
    };
  }
  handleEnterEditMode = (row) => {
    // this.setState({ cData: { ...row }, isEditing: true });
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    this.setState({
      chartId: row.chartId,
      chartName: row.chartName,
      chartDescription: row.chartDescription,
      minHeight: row.minHeight,
      maxHeight: row.maxHeight,
      minWidth: row.minWidth,
      maxWidth: row.maxWidth,
      charttypemaster_Id: row.charttypemaster_Id,
      isEditing: true,
    });
  };
  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      chartId: "",
      chartName: "",
      chartDescription: "",
      minHeight: "",
      maxHeight: "",
      minWidth: "",
      maxWidth: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFour: "",
      dummyFive: "",
      dummysix: "",
      dummyseven: "",
    });
  };
  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({ show: false });
  };
  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };
  CharttypemastereditHandler = (e) => {
    e.preventDefault();
    // const updateFormData = {...editFormData};
    // updateFormData['Charttypemaster_Id'] = e.target.parentElement.getAttribute("id");
    // setEditFormData(updateFormData);
    // setEdit(true);
  };

  CharttypemasterfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Charttypemaster/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        } else {
          this.showToast(data.message || "Failed to load chart types", "error");
        }
      })
      .catch((error) => {
        console.error("Error fetching chart type master:", error);
        this.showToast("Failed to load chart types. Please try again.", "error");
      });
  };
  CharttypemastersubmitHandler = (e) => {
    e.preventDefault();
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("chartId", this.state.chartId);
    formData.append("chartName", this.state.chartName);
    formData.append("chartDescription", this.state.chartDescription);
    formData.append("minHeight", this.state.minHeight);
    formData.append("maxHeight", this.state.maxHeight);
    formData.append("minWidth", this.state.minWidth);
    formData.append("maxWidth", this.state.maxWidth);
    formData.append("dummyOne", this.state.dummyOne);
    formData.append("dummyTwo", this.state.dummyTwo);
    formData.append("dummyThree", this.state.dummyThree);
    formData.append("dummyFour", this.state.dummyFour);
    formData.append("dummyFive", this.state.dummyFive);
    formData.append("dummysix", this.state.dummysix);
    formData.append("dummyseven", this.state.dummyseven);
    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Charttypemaster/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      
        this.setState({ loading: false });})
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.CharttypemasterfetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            chartId: "",
            chartName: "",
            chartDescription: "",
            minHeight: "",
            maxHeight: "",
            minWidth: "",
            maxWidth: "",
            dummyOne: "",
            dummyTwo: "",
            dummyThree: "",
            dummyFour: "",
            dummyFive: "",
            dummysix: "",
            dummyseven: "",
          });
        }
      })
      .catch((error) => {
        console.error("Error adding chart type:", error);
        this.showToast("Failed to add chart type. Please try again.", "error");
      
        this.setState({ loading: false });});
  };
  CharttypemasterupdateHandler = (e, row) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("chartId", this.state.chartId);
    formData.append("chartName", this.state.chartName);
    formData.append("chartDescription", this.state.chartDescription);
    formData.append("minHeight", this.state.minHeight);
    formData.append("maxHeight", this.state.maxHeight);
    formData.append("minWidth", this.state.minWidth);
    formData.append("maxWidth", this.state.maxWidth);
    formData.append("dummyOne", this.state.dummyOne);
    formData.append("dummyTwo", this.state.dummyTwo);
    formData.append("dummyThree", this.state.dummyThree);
    formData.append("dummyFour", this.state.dummyFour);
    formData.append("dummyFive", this.state.dummyFive);
    formData.append("dummysix", this.state.dummysix);
    formData.append("dummyseven", this.state.dummyseven);
    formData.append("charttypemaster_Id", this.state.charttypemaster_Id);
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Charttypemaster/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      
        this.setState({ loading: false });})
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.CharttypemasterfetchHandler();
          this.handleOffcanvasClose();
        }
      })
      .catch((error) => {
        console.error("Error updating chart type:", error);
        this.showToast("Failed to update chart type. Please try again.", "error");
      
        this.setState({ loading: false });});
  };

  componentDidMount() {
    this.CharttypemasterfetchHandler();
  }
  handlechartIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ chartId: fieldValue });
  };
  handlechartNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ chartName: fieldValue });
  };
  handlechartDescriptionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ chartDescription: fieldValue });
  };
  handleminHeightChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ minHeight: fieldValue });
  };
  handlemaxHeightChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ maxHeight: fieldValue });
  };
  handleminWidthChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ minWidth: fieldValue });
  };
  handlemaxWidthChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ maxWidth: fieldValue });
  };
  handledummyOneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyOne: fieldValue });
  };
  handledummyTwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyTwo: fieldValue });
  };
  handledummyThreeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyThree: fieldValue });
  };
  handledummyFourChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyFour: fieldValue });
  };
  handledummyFiveChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyFive: fieldValue });
  };
  handledummysixChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummysix: fieldValue });
  };
  handledummysevenChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyseven: fieldValue });
  };
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
    // implement your edit logic here
  };
  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append("charttypemaster_Id", row.charttypemaster_Id);
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Charttypemaster/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      
        this.setState({ loading: false });})
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.CharttypemasterfetchHandler();
        }
      })
      .catch((error) => {
        console.error("Error deleting chart type:", error);
        this.showToast("Failed to delete chart type. Please try again.", "error");
      
        this.setState({ loading: false });});
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="align-items-center mb-3">
                    <Col xs={12} sm={6} md={8}>
                      <h3
                        className="logoskybluecolor mb-0"
                        style={{ textAlign: "start" }}
                      >
                        Chart Type Master
                      </h3>
                    </Col>
                    <Col
                      xs={12}
                      sm={6}
                      md={4}
                      className="d-flex justify-content-end mt-2 mt-sm-0"
                    >
                      <Offcanvas
                        show={this.state.show}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            Charttypemaster page
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row className="mb-3">
                                    <Col xs={12} sm={4} md={4}>
                                      <Form.Label className="form-label">
                                        Chart Id
                                      </Form.Label>
                                    </Col>
                                    <Col xs={12} sm={8} md={8}>
                                      <Form.Control
                                        type="number"
                                        onChange={this.handlechartIdChange}
                                        className="form-control"
                                        name="chartId"
                                        value={this.state.chartId}
                                        required="required"
                                        placeholder="Enter chartId"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.chartId}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Chart Name
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlechartNameChange}
                                        className="form-control"
                                        name="chartName"
                                        value={this.state.chartName}
                                        required="required"
                                        placeholder="Enter chartName"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.chartName}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Chart Description
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlechartDescriptionChange
                                        }
                                        className="form-control"
                                        name="chartDescription"
                                        value={this.state.chartDescription}
                                        required="required"
                                        placeholder="Enter chartDescription"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.chartDescription}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Minimum Height
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleminHeightChange}
                                        className="form-control"
                                        name="minHeight"
                                        value={this.state.minHeight}
                                        required="required"
                                        placeholder="Enter minHeight"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.minHeight}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Maximum Height
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlemaxHeightChange}
                                        className="form-control"
                                        name="maxHeight"
                                        value={this.state.maxHeight}
                                        required="required"
                                        placeholder="Enter maxHeight"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.maxHeight}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Minimum Width
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleminWidthChange}
                                        className="form-control"
                                        name="minWidth"
                                        value={this.state.minWidth}
                                        required="required"
                                        placeholder="Enter minWidth"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.minWidth}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Maximum Width
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlemaxWidthChange}
                                        className="form-control"
                                        name="maxWidth"
                                        value={this.state.maxWidth}
                                        required="required"
                                        placeholder="Enter maxWidth"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.maxWidth}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.CharttypemastersubmitHandler}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <div>
                    {" "}
                    {this.state.isEditing && (
                      // Edit Offcanvas
                      <Offcanvas
                        show={this.state.isEditing}
                        onHide={() => this.setState({ isEditing: false })}
                        {...this.props}
                        style={{ width: "500px", height: "auto" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            Edit Chart typemaster page
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <div className="form-horizontal form-label-left input_mask">
                            <Form className="form-horizontal form-label-left input_mask">
                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Chart Id
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handlechartIdChange}
                                          className="form-control"
                                          name="chartId"
                                          value={this.state.chartId}
                                          required="required"
                                          placeholder="Enter chartId"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.chartId}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Chart Name
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlechartNameChange}
                                          className="form-control"
                                          name="chartName"
                                          value={this.state.chartName}
                                          required="required"
                                          placeholder="Enter chartName"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.chartName}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Chart Description
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlechartDescriptionChange
                                          }
                                          className="form-control"
                                          name="chartDescription"
                                          value={this.state.chartDescription}
                                          required="required"
                                          placeholder="Enter chartDescription"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.chartDescription
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Minimum Height
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleminHeightChange}
                                          className="form-control"
                                          name="minHeight"
                                          value={this.state.minHeight}
                                          required="required"
                                          placeholder="Enter minHeight"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.minHeight}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Maximum Height
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlemaxHeightChange}
                                          className="form-control"
                                          name="maxHeight"
                                          value={this.state.maxHeight}
                                          required="required"
                                          placeholder="Enter maxHeight"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.maxHeight}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Minimum Width
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleminWidthChange}
                                          className="form-control"
                                          name="minWidth"
                                          value={this.state.minWidth}
                                          required="required"
                                          placeholder="Enter minWidth"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.minWidth}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Maximum Width
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlemaxWidthChange}
                                          className="form-control"
                                          name="maxWidth"
                                          value={this.state.maxWidth}
                                          required="required"
                                          placeholder="Enter maxWidth"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.maxWidth}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                  </Form>
                                </Row>
                              </Row>
                              <br />
                              <div style={{ float: "right" }}>
                                <button
                                  className="btn btn-primary me-2 mt-5"
                                  style={{
                                    backgroundColor: "#23547e",
                                    color: "#fff",
                                    borderColor: "#2e6da4",
                                  }}
                                  onClick={this.CharttypemasterupdateHandler}
                                >
                                  Update
                                </button>
                              </div>
                            </Form>
                          </div>
                        </Offcanvas.Body>
                      </Offcanvas>
                    )}
                  </div>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <Button
                        variant="primary"
                        className="bi bi-plus "
                        style={{ float: "right" }}
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
